/*
 * Assignment component specific for Adalia M&E.
 * This is a composite based on other components.
 */

 import React from 'react';

import DropdownSelection from './dropdown_selection.jsx';
 
export default class AdaliaMEAssignment extends DropdownSelection {

    static get TYPE() {
        return 'adalia_me_assignment'
    }

    static get TRANSLATED_ATTRIBUTES() {
        return {
            label: 'component_title_adalia_me_assignment',
            placeholder: 'field_default_placeholder',
            description: 'field_default_description',
            help: null,
            unit: null,
            blankOptionLabel: 'select_blank_option_default'
        };
    }

    static defaultContent(language) {
        return Object.assign(super.defaultContent(language), {
            name: 'assignment',
            required: false,
            cloneable: false,
            reportKey: 'assignment',
            blankOptionLabel: 'blankOptionLabel'
        });
    }

}